import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

/**
 * Reusable search input for tree filtering
 * @param {Object} props
 * @param {string} props.value - Current search value
 * @param {function} props.onChange - Callback when search value changes
 * @param {string} props.placeholder - Custom placeholder text (optional)
 * @param {string} props.className - Additional CSS classes (optional)
 * @param {string} props.width - Custom width (optional, e.g., '100%')
 */
const TreeSearchInput = ({
  value,
  onChange,
  placeholder,
  className = '',
  width,
}) => {
  const { t } = useTranslation();

  const inputClassName = width
    ? 'border-gray-300 rounded-[8px]'
    : 'border-gray-300 w-full sm:w-[280px] rounded-[8px]';

  return (
    <div
      className={`tree-search-input ${className}`}
      onClick={(e) => e.stopPropagation()}
    >
      <Input
        placeholder={placeholder || t('common|Recherche sur l\'ensemble...')}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        allowClear
        suffix={<SearchOutlined className="text-[#000]" />}
        className={inputClassName}
        style={width ? { width } : undefined}
      />
    </div>
  );
};

export default TreeSearchInput;
